<div class="provider-enrollment-forms">
  @if (loading) {
  <div class="loading-container">
    <p>Loading forms...</p>
  </div>
  }

  @if (error) {
  <div class="error-container">
    <p class="error-message">{{ errorMessage }}</p>
  </div>
  }

  @if (!loading && !error && forms.length > 0) {
  <div class="enrollment-wizard">
    <div class="wizard-content">
      <!-- Left Sidebar Navigation -->
      <aside class="wizard-sidebar">
        <nav class="form-navigation">
          @if (checklistGroups && checklistGroups.length > 0) {
            @for (group of checklistGroups; track $index; let isLast = $last) {
              <div class="checklist-group-header" [class.incomplete]="group.totalItemsCompleted !== group.totalItems">
                <strong>{{ group.checklistName }}</strong>
                <div style="font-size: x-small; text-align: right;">{{ group.totalItemsCompleted }}/{{ group.totalItems }} completed</div>
              </div>
              @for (item of group.items; track item.checklistItemId + '_' + item.checklistItemDetailId) {
                @if (item.form) {
                  @if(!item.hide){
                  <button type="button" class="nav-item"
                    [class.active]="currentChecklist === item"
                    (click)="navigateToChecklistByItem(item); $event.stopPropagation()"
                    [attr.aria-current]="currentChecklist === item ? 'page' : null">
                    <span class="nav-item-title">{{ item.form.title }}</span>
                    @if (item.formStatus === 'C') {
                      <span class="nav-item-icon completed-icon" title="Form signed and completed">✓</span>
                    } @else if (item.formMasterId !== 113 && item.formStatus === 'I') {
                      <span class="nav-item-icon incomplete-icon" title="Yet to sign the form">!</span>
                    }
                  </button>
                }
                } @else {
                  <div class="nav-item nav-item-unavailable">
                    <span class="nav-item-title">{{ item.formDesc || 'Form Not Available' }}</span>
                    <span class="nav-item-error">Not configured</span>
                  </div>
                }
              }
              @if (!isLast) {
                <hr class="sidebar-divider">
              }
            }
          }
        </nav>
      </aside>

      <!-- Main Form Area -->
      <main class="wizard-main">
        @if (currentChecklist?.form) {
        <ppl-dynamic-form-renderer [formConfig]="currentChecklist.form" [checklistItem]="currentChecklist"
          [providerId]="providerId"
          [selectedProviderType]="selectedProviderType" [selectedParticipantId]="selectedParticipantId"
          [programCode]="programCode" [readonly]="isReadOnly" [hideFormActions]="true"
          [linkedSaveConfig]="linkedSaveConfig"
          (formSaved)="onFormSaved($event)"
          (formChanged)="onFormChanged($event)"></ppl-dynamic-form-renderer>

        @if (isW9Form()) {
        <nz-alert nzType="warning" nzShowIcon class="w9-confirmation-note"
          nzMessage="Please confirm all the information above is correct — it will be used to complete your IRS Form W-9. To update your Mailing Address or Taxpayer Identification Number (SSN or EIN), please make the change in the Enrollment Information tab; this form does not accept corrections to those fields.">
        </nz-alert>
        }

        <div class="spending-plan-buttons" nz-col style="margin-left: 8px;">
          <nz-form-item>
            @if (hasQuestionnaireFields() && !isReadOnly) {
            <ppl-button label="Save Form" icon="fa fa-save" [disabled]="disableSave" style="margin-right: 15px;"
              [customClass]="'primary-button'" [iconPosition]="'left'" (click)="onSave()"></ppl-button>
            }

            @if (!disableActions) {
            <ppl-button [label]="currentChecklist?.formStatus === 'C' || currentChecklist?.formMasterId === 113 ? 'View Form' : 'Sign Form'"
              [icon]="currentChecklist?.formStatus === 'C' || currentChecklist?.formMasterId === 113 ? 'fa fa-eye' : 'fa fa-pencil'" style="margin-right: 8px;"
              [customClass]="'ghost-button'" [iconPosition]="'left'"
              (click)="onAction('edit')"></ppl-button>

            <ppl-button label="Download" icon="fa fa-download" style="margin-right: 8px;" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="onAction('download')"></ppl-button>

            <!-- Mail button hidden -->
            <!-- <ppl-button label="Mail" icon="fa fa-envelope" style="margin-right: 8px;" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="onAction('requestMail')"></ppl-button> -->

            <ppl-button label="Show Form History" icon="fa fa-refresh" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="onAction('history')"></ppl-button>
            }
            @else if(isReadOnly) {
              <ppl-button [label]="currentChecklist?.formStatus === 'C' || currentChecklist?.formMasterId === 113 ? 'View Form' : 'Sign Form'"
              [icon]="currentChecklist?.formStatus === 'C' ? 'fa fa-eye' : 'fa fa-pencil'" style="margin-right: 8px;"
              [customClass]="'ghost-button'" [iconPosition]="'left'"
              (click)="onAction('edit')"></ppl-button>
            }
          </nz-form-item>
        </div>
        }
      </main>
    </div>
  </div>
  }

  @if (!loading && !error && forms.length === 0) {
  <div class="no-forms-container">
    <p>Forms are not applicable to your association with the participant.</p>
  </div>
  }
</div>